import moment from 'moment';
import React, { useEffect, useState } from 'react';
import useSWR from 'swr';

import MainButton from '@/components/UI/mobile/MainButton';
import type { GetFeedbackData } from '@/types/database/feedback';

import FeedbackItem from '../FeedbackItem';
import { feedbacksFetcher } from './helpers';
import styles from './index.module.scss';

const FeedbackList: React.FC<{
  householdNumber: string;
  handleCreate: () => void;
  handleShowMessage: (feedback: GetFeedbackData[number]) => void;
}> = ({ householdNumber, handleCreate, handleShowMessage }) => {
  const [feedbacks, setFeedbacks] = useState<GetFeedbackData>([]);
  const [fetchPage, setFetchPage] = useState(1);
  const [keepFetching, setKeepFetching] = useState(false);

  const { data: fetchFeedbackData, isLoading } = useSWR(
    [fetchPage, householdNumber],
    feedbacksFetcher
  );

  useEffect(() => {
    if (!fetchFeedbackData) {
      return;
    }
    if (fetchFeedbackData.length === 0) {
      setKeepFetching(true);
      return;
    }
    if (fetchPage === 1) {
      setFeedbacks(fetchFeedbackData);
    } else {
      setFeedbacks((prev) => {
        const prevOldestFeedback = prev[prev.length - 1];
        const newsetFetchFeedback = fetchFeedbackData[0];
        const shouldAppend = moment(prevOldestFeedback?.createdTime).isAfter(
          newsetFetchFeedback?.createdTime
        );
        if (shouldAppend) {
          return [...prev, ...fetchFeedbackData];
        }
        return prev;
      });
    }
  }, [fetchFeedbackData, fetchPage]);

  return (
    <div className={styles.feedbacksPage}>
      <MainButton
        className={styles.create}
        disableRipple
        onClick={handleCreate}
      >
        新增意見反應
      </MainButton>
      <div
        className={styles.feedbackList}
        onScroll={(e) => {
          const target = e.target;
          if (target instanceof HTMLDivElement) {
            const { scrollTop, scrollHeight, offsetHeight } = target;
            if (scrollHeight - offsetHeight - scrollTop > 200) {
              return;
            }
            if (!keepFetching && !isLoading) {
              setFetchPage((prev) => prev + 1);
            }
          }
        }}
      >
        {feedbacks?.map((feedback) => (
          <FeedbackItem
            key={feedback._id}
            showMessage={() => handleShowMessage(feedback)}
            feedback={feedback}
          />
        ))}
      </div>
    </div>
  );
};

export default FeedbackList;
